import Ws from "../../providers/Ws";
import Utils from "../../providers/Utils";

export default class FromServer {

    listRaport = []
    listRaportGroupedByUser = []

    getRaportUtilizatori = async(sortBy) =>{
        let ws = new Ws();

        let raport = await ws.customSelect(`select t.id,t.id_categorie,t.id_proiect,t.titlu,t.descriere,t.cand_data,t.cand_ora,t.pana_cand_data,t.pana_cand_ora,t.statusul,t.id_utilizator_responsabil,

        Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)  as dataora_propusa,   
        t.cand_finalizat as dataora_finalizare,
        
        DATEDIFF(HOUR, (Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)) , isnull(t.cand_finalizat,GetDate())  ) as ore_diferenta_completare,
        
        DATEDIFF(HOUR, (Cast(t.cand_data as datetime)  + Cast(isnull(t.cand_ora,'09:00') as datetime)) , ( Cast(t.pana_cand_data as datetime) +Cast( isnull(t.pana_cand_ora,'23:59') as datetime))  ) ore_durata,
        
        u.nume as nume_user, p.titlu as nume_proiect , p.descriere as descriere_proiect, p.perioada_dela as start_proiect, perioada_panala as end_proiect
        
        from taskuri t left outer join useri u on (t.id_utilizator_responsabil = u.id ) left outer join proiecte p on(t.id_proiect = p.id) where isnull(t.inactiv,0) != @p1 `,
            { p1: 1 })

        // console.log('raport :', raport);

        if (raport.Succes) {
            this.listRaport = raport.Content


            let userIds = this.listRaport.map(l => l.id_utilizator_responsabil)


            let userRez = []

            let users = [...new Set(userIds)]




            // console.log('users :', users);


            let counter = users.length


            for (let i = 0; i < counter; i++) {
                userRez.push(this.userAnalize1(users[i], this.listRaport))
            }

            this.listRaportGroupedByUser = userRez
           return  this.sortDs(sortBy)

        }

    }


    sortDs = (sortBy) =>{
        let s = this.listRaportGroupedByUser.sort((a, b) => {
            if (a[sortBy] < b[sortBy]) {
                return -1
            };
            return 1
        })

        let chartData = [['Angajat',
            'Medie generala',
            'Medie avans / task',
            'Medie depasire / task',
            'Nr. taskuri avans',
            'Nr. taskuri depasite',
            'Nr. taskuri termen',
            'Nr. total taskuri',
            'Total ore avans',
            'Total ore depasite',
            'Total ore cumulate taskuri',
            'Total ore diferenta completare',
            'Procentaj depasire']]

        let chartData2 = [['Angajat',
            'Total ore cumulate taskuri',
            'Total ore depasire completare',
            'Total ore avans completare',
            'Procentaj depasire',
            'Procentaj avans']]




        let counter = s.length

        for (let i = 0; i < counter; i++) {
            chartData.push([s[i].numeUser,
            s[i].medieGenerala,
            s[i].medieAvansPerTask,
            s[i].medieDepasirePerTask,
            s[i].nrTaskuriAvans,
            s[i].nrTaskuriDepasite,
            s[i].nrTaskuriInTermen,
            s[i].nrTotalTaskuri,
            s[i].totalOreAvans,
            s[i].totalOreDepasire,
            s[i].totalOreCumulateTaskuri,
            s[i].totalOreDiferentaCompletare,
            s[i].pctDepasire])

            chartData2.push([
                s[i].numeUser,
                s[i].totalOreCumulateTaskuri,
                s[i].totalOreDiferentaCompletare > 0 ? Math.abs(s[i].totalOreDiferentaCompletare) : 0,
                s[i].totalOreDiferentaCompletare < 0 ? Math.abs(s[i].totalOreDiferentaCompletare) : 0,
                s[i].pctDepasire > 0 ? Math.abs(s[i].pctDepasire) : 0,
                s[i].pctDepasire < 0 ? Math.abs(s[i].pctDepasire) : 0,
                ])
        }

        return {s:s, chartData:chartData, chartData2:chartData2}
    }

    userAnalize1 = (idUser, ds) => {

        let DT = ds.filter(l => l.id_utilizator_responsabil === idUser)

        let nrTotalTaskuri = DT.length

        let nrTaskuriDepasite = DT.filter(d => Number(d.ore_diferenta_completare) > 0).length

        let nrTaskuriAvans = DT.filter(d => Number(d.ore_diferenta_completare) < 0).length

        let nrTaskuriInTermen = DT.filter(d => Number(d.ore_diferenta_completare) === 0).length

        let totalOreDepasire = DT.filter(d => (Number(d.ore_diferenta_completare) || 0) > 0).reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let totalOreCumulateTaskuri = DT.reduce((s, a) => s + (Number(a.ore_durata) || 0), 0)

        let totalOreDiferentaCompletare = DT.reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let pctDepasire = Number((totalOreDiferentaCompletare / (totalOreCumulateTaskuri || 1) * 100).toFixed(2))

        let totalOreAvans = DT.filter(d => Number(d.ore_diferenta_completare) < 0).reduce((s, a) => s + (Number(a.ore_diferenta_completare) || 0), 0)

        let medieDepasirePerTask = Number((totalOreDepasire / (nrTotalTaskuri || 1)).toFixed(2))

        let medieAvansPerTask = Number((totalOreAvans / (nrTotalTaskuri || 1)).toFixed(2))

        let medieGenerala = Number((Number(medieAvansPerTask) - Math.abs(medieDepasirePerTask)).toFixed(2))

        let calificativMedie = medieGenerala < 0 ? 'Pozitiva' : 'Negativa'


        let numeUser = DT[0].nume_user

        return {
            nrTotalTaskuri,
            nrTaskuriDepasite,
            nrTaskuriAvans,
            nrTaskuriInTermen,
            totalOreDepasire,
            totalOreAvans,
            medieDepasirePerTask,
            medieAvansPerTask,
            medieGenerala,
            calificativMedie,
            numeUser,
            totalOreCumulateTaskuri,
            totalOreDiferentaCompletare,
            pctDepasire
        }



    }

    getRaportTimp = async() =>{
        let ws = new Ws();

        let raport = await ws.customSelect(`select t.id,t.id_categorie,t.id_proiect,t.titlu,t.descriere,t.cand_data,t.cand_ora,t.pana_cand_data,t.pana_cand_ora,t.statusul,t.id_utilizator_responsabil,

        Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)  as dataora_propusa,   
        t.cand_finalizat as dataora_finalizare,
        
        DATEDIFF(HOUR, (Cast(t.pana_cand_data as datetime)  + Cast(isnull(t.pana_cand_ora,'23:59') as datetime)) , isnull(t.cand_finalizat,GetDate())  ) as ore_diferenta_completare,
        
        DATEDIFF(HOUR, (Cast(t.cand_data as datetime)  + Cast(isnull(t.cand_ora,'09:00') as datetime)) , ( Cast(t.pana_cand_data as datetime) +Cast( isnull(t.pana_cand_ora,'23:59') as datetime))  ) ore_durata,
        
        u.nume as nume_user, p.titlu as nume_proiect , p.descriere as descriere_proiect, p.perioada_dela as start_proiect, perioada_panala as end_proiect
        
        from taskuri t left outer join useri u on (t.id_utilizator_responsabil = u.id ) left outer join proiecte p on(t.id_proiect = p.id) where isnull(t.inactiv,0) != @p1 `,
            { p1: 1 })

        // console.log('raport :', raport);

        if (raport.Succes) {

            // console.log('raport.Content :', raport.Content);

            let uIds = raport.Content.map(i => i.id_utilizator_responsabil)

            let users = [...new Set(uIds)]

            let pIds = raport.Content.map(p => p.id_proiect)

            pIds = pIds.filter(p => p !== null)

            let proiecte = [...new Set(pIds)]

            // console.log('users :', users);
            // console.log('pIds :', proiecte);

            let counter1 = users.length

            let counter2 = proiecte.length

            let u = []
            let p = []

            for (let i = 0; i < counter1; i++) {
                let us = raport.Content.filter(r => r.id_utilizator_responsabil === users[i])

                u.push({ id: users[i], nume: us[0].nume_user })
            }

            for (let i = 0; i < counter2; i++) {
                let pr = raport.Content.filter(r => r.id_proiect === proiecte[i])

                p.push({ id: proiecte[i], nume: pr[0].nume_proiect })
            }

            // console.log('u :', u);
            // console.log('p :', p);


            let userRez = []

            userRez = this.userAnalize1Timp(raport.Content)

            // console.log('userRez :', userRez);

            return {r:true, m:raport.Messsage, c:{userRez, u:u,p:p}}
        }else{
            return {r:false, m:raport.Messsage, c:null}
        }
    }

    userAnalize1Timp = (ds) => {

        let u = new Utils();



        let counter = ds.length

        let tasks = []

        // console.log('ds :', ds);

        for (let i = 0; i < counter; i++) {


            let objToAdd = {
                id_utilizator_responsabil: ds[i].id_utilizator_responsabil,
                id_proiect: ds[i].id_proiect,
                nume_user: ds[i].nume_user,
                nume_proiect: ds[i].nume_proiect,
                nume_task: ds[i].titlu,
                de_la: u.ParseDataFromSql(ds[i].cand_data),
                pana_la: u.ParseDataFromSql(ds[i].pana_cand_data),
                durata_ore: ds[i].ore_durata !== null ? ds[i].ore_durata : 1,
                ore_depasire: ds[i].ore_diferenta_completare !== null ? (ds[i].ore_diferenta_completare > 0 ? Math.abs(ds[i].ore_diferenta_completare) : '') : '',
                ore_avans: ds[i].ore_diferenta_completare !== null ? (ds[i].ore_diferenta_completare < 0 ? Math.abs(ds[i].ore_diferenta_completare) : '') : '',


            }

            tasks.push(objToAdd)

        }


        return tasks

    }

    getSituatiiGenerale = async(id) =>{
        let ws = new Ws();

        let proiect = ws.proc('rap_proiect_overview',{p1:id})

        let etape = ws.proc('rap_proiect_etape_overview',{p1:id})

        let [p,e] = await Promise.all([proiect,etape])


        if(p.Succes, e.Succes){
            return [p.Content,e.Content]
        }
    }

    getProiecte = async() =>{
        let ws = new Ws();

        
        let proiecte = await ws.customSelect('select * from proiecte where 1 = @p1', {
            p1: 1
        })

        if(proiecte.Succes){
            return {r:true, m:proiecte.Messsage, c:proiecte.Content}
        }else{
            return {r:false, m:proiecte.Message, c:null}
        }
    }

}